<template>
  <div id="app">
    <base-spinner/>
    <template v-if="showLayout">
      <TopBar/>
      <div class="d-flex flex-row w-100 app-body">
        <layout-navigation/>
        <div class="app-main-content">
          <router-view/>
        </div>
      </div>
    </template>
    <router-view v-else/>
  </div>
</template>

<script>
import BaseSpinner from './components/global/BaseSpinner'
import LayoutNavigation from './components/layout/LayoutNavigation.vue'
import TopBar from './components/layout/TopBar.vue'
import { useTheme } from './composables/useTheme'

export default {
  name: 'App',
  components: {
    BaseSpinner,
    LayoutNavigation,
    TopBar
  },
  computed: {
    showLayout () {
      const currentPath = this.$route.path
      const isEvaluationRoute = currentPath.startsWith('/evaluation')
      return !isEvaluationRoute && currentPath !== '/' && currentPath !== '/login' && currentPath !== '/reset/password'
    }
  },
  mounted () {
    const { initTheme } = useTheme()
    initTheme()
    this.checkAffiliate()
    setTimeout(() => {
      this.$root.$emit('Spinner::hide')
    }, 500)
  },
  methods: {
    async checkAffiliate () {
      if (!window.uid || !this.$firebase.auth().currentUser) {
        await this.safeLogoutAndRedirect()
        return
      }

      try {
        const ref = this.$firebase.database().ref(`affiliates/${window.uid}`)
        const snapshot = await ref.once('value')
        const user = snapshot.val()
        if (user?.actived) {
          return
        }
        await this.safeLogoutAndRedirect()
      } catch (err) {
        console.warn('DB read failed:', err)
        await this.safeLogoutAndRedirect()
      }
    },
    async safeLogoutAndRedirect () {
      try {
        window.uid = null
        await this.$firebase.auth().signOut()
      } catch (e) {
        console.warn('signOut error:', e)
      }
      if (this.$route.name !== 'login') {
        this.$router.replace({ name: 'login' }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Erro na navegação:', err)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  height: 100vh !important;
  height: 100dvh !important;
  background-color: var(--surface-tertiary);
  display: flex;
  flex-direction: column;

  .dark & {
    background-color: var(--surface-secondary);
  }
}

.app-body {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.app-main-content {
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 768px) {
  html,
  body {
    height: 100%;
    overflow: hidden;
  }

  #app {
    height: 100dvh !important;
    overflow: hidden;
  }

  .app-body {
    display: flex !important;
    flex-direction: row;
    position: relative;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .app-main-content {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .app-main-content > * {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 0;
    width: 100%;
    height: auto !important;
    max-height: none !important;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
  }
}
</style>
